import React, { FC, forwardRef } from 'react';
import Link from 'next/link';

import {
  SectionsListItem,
  SectionsListItemContainer,
  StyledSectionIcon,
} from '../styledComponents';

import { addSlugToUrl } from 'services/common';
import { SectionTree, SectionTypeTree } from 'types/common';
import { SUBPATH_TYPES } from 'constants/common';

type SectionTypeListProps = {
  currentSection: string;
  isPos?: boolean;
  sectionType: string;
  sectionTree: SectionTree;
  sectionTypeTree: SectionTypeTree;
  closeModal?: () => void;
};

const sectionIconSize = '112';

const ForwardedSectionsListItem =
  // eslint-disable-next-line prefer-arrow-callback
  forwardRef(function CustomSectionsListItem(
    {
      href,
      sectionId,
      sectionTree,
      currentSection,
    }: {
      href?: string;
      sectionId: string;
      closeModal?: () => void;
      sectionTree: SectionTree;
      currentSection: string;
    },
    /* eslint-disable @typescript-eslint/no-unused-vars */
    _ref,
  ) {
    return (
      <SectionsListItem href={href} selected={currentSection === sectionId}>
        {sectionTree[sectionId].sectionTitle}
      </SectionsListItem>
    );
  });

const SectionTypeList: FC<SectionTypeListProps> = ({
  currentSection,
  isPos,
  sectionTree,
  sectionType,
  sectionTypeTree,
}) => (
  <>
    {sectionTypeTree[sectionType].map((sectionId) => (
      <SectionsListItemContainer key={sectionId}>
        {sectionTree[sectionId].icon ? (
          <StyledSectionIcon
            src={`${sectionTree[sectionId].icon.url}?w=${sectionIconSize}&h=${sectionIconSize}`}
            alt={sectionTree[sectionId].icon.name}
            width="40"
            height="40"
          />
        ) : null}
        <Link
          passHref
          href={addSlugToUrl({
            subPath: SUBPATH_TYPES.sections,
            contentId: sectionId,
            contentSlug: sectionTree[sectionId].slug,
            isPos,
          })}
        >
          <ForwardedSectionsListItem
            sectionTree={sectionTree}
            currentSection={currentSection}
            sectionId={sectionId}
          />
        </Link>
      </SectionsListItemContainer>
    ))}
  </>
);

export default SectionTypeList;
